import React from "react";
import { cn } from "@/lib/utils";

interface ChatContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Main chat container wrapper
 * Full-screen layout with header, messages, and input
 */
export function ChatContainer({ children, className }: ChatContainerProps) {
  return (
    <div
      className={cn(
        "flex flex-col h-full w-full bg-background",
        // Animation
        "animate-in fade-in duration-200",
        className,
      )}
    >
      {children}
    </div>
  );
}

interface ChatHeaderSlotProps {
  children: React.ReactNode;
}

export function ChatHeaderSlot({ children }: ChatHeaderSlotProps) {
  return <header className="shrink-0 shadow-sm z-10">{children}</header>;
}

interface ChatMessagesSlotProps {
  children: React.ReactNode;
}

export function ChatMessagesSlot({ children }: ChatMessagesSlotProps) {
  return (
    <main className="flex-1 overflow-hidden bg-background">{children}</main>
  );
}

interface ChatInputSlotProps {
  children: React.ReactNode;
}

export function ChatInputSlot({ children }: ChatInputSlotProps) {
  return <footer className="shrink-0 bg-background">{children}</footer>;
}
